import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError, } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnvironmentConfiguration } from '../environment/services/environment.configuration';
var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
var httpOptions;
if (isIEOrEdge) {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
    })
  };
} else {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('Ebom_accessToken'),
      'x-api-key':localStorage.getItem('Filename')
    })
  };
}
@Injectable({
  providedIn: 'root'
})
export class ExtraneousPartsListServiceService {
  [x: string]: any;

  headers = new HttpHeaders().set('Content-Type', 'application/json');
  extraneousPartType = '/getExtraneousPartType/{proxy+}'
  matchingPartText = '/getMatchingPartText/{proxy+}'
  componentCode = '/getComponentCode/{proxy+}'
  sourceRouting = '/getSourceRouting/{proxy+}'
  destRouting = '/getDestRouting/{proxy+}'
  gridData = '/getExtPartsLstGrid/{proxy+}'

  constructor(private http: HttpClient, private environment: EnvironmentConfiguration) { }

  //extraneousPartType
  getExtraneousPartType(): Observable<any> {
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.Mastersearchdropdown2apiUrl + this.extraneousPartType+'?screenNo=NBPC_2250'+'&fileName=' +fileName;
    return this.http.get(API_URL,httpOptions)
      .pipe(
        catchError(this.error)
      )
  }


  //matchingPartText
  getMatchingPartText(splPartTypNm): Observable<any> {
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let matchingPartTextParams = new HttpParams().set('splPartTypNm', splPartTypNm);
    let API_URL = this.environment.Mastersearchdropdown2apiUrl + this.matchingPartText + "?splPartTypNm=" + splPartTypNm+'&screenNo=NBPC_2250'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)
      )
  }


  //componentCode
  getComponentCode(splPartTypNm, matchingPartText): Observable<any> {
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let compCodeParams = new HttpParams().set('splPartTypNm', splPartTypNm)
    //   .append('matchingPartText', matchingPartText);
    let API_URL = this.environment.Mastersearchdropdown2apiUrl + this.componentCode + '?splPartTypNm='+splPartTypNm +
    '&matchingPartText=' + matchingPartText+'&screenNo=NBPC_2250'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)
      )
  }
  //sourceRouting
  getSourceRouting(splPartTypNm, matchingPartText, cmpntCode): Observable<any> {
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let sourceParams = new HttpParams().set('splPartTypNm', splPartTypNm)
    //   .append('matchingPartText', matchingPartText)
    //   .append('cmpntCode', cmpntCode);
    let API_URL = this.environment.Mastersearchdropdown2apiUrl + this.sourceRouting + '?splPartTypNm=' + splPartTypNm + 
    '&matchingPartText=' + matchingPartText + '&cmpntCode='+ cmpntCode +'&screenNo=NBPC_2250'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)
      )
  }

  //destRouting
  getDestRouting(splPartTypNm, matchingPartText, cmpntCode, sourceRouting): Observable<any> {
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let destParams = new HttpParams().set('splPartTypNm', splPartTypNm)
    //   .append('matchingPartText', matchingPartText)
    //   .append('cmpntCode', cmpntCode)
    //   .append('sourceRouting', sourceRouting);
    let API_URL = this.environment.Mastersearchdropdown3apiUrlrest1 + this.destRouting + '?splPartTypNm=' +  splPartTypNm +
    '&matchingPartText='+ matchingPartText + '&cmpntCode='+cmpntCode + '&sourceRouting='+ sourceRouting+'&screenNo=NBPC_2250'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)
      )
  }


  //grid data
  getGridData(gridData): Observable<any> {
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let gridParams = new HttpParams().set('spclPartTypNm', gridData.extraneousPartType)
    //   .append('mtchgPartKywrdTxt', gridData.matchingPartText)
    //   .append('srcRtgCd', gridData.sourceRouting)
    //   .append('cmpntCd', gridData.componentCode)
    //   .append('destRtgCd', gridData.destRouting)
    let API_URL = this.environment.MastergridapiUrl +'/getExtPartsLstGrid/{proxy+}' + '?spclPartTypNm=' + gridData.extraneousPartType + '&mtchgPartKywrdTxt=' + gridData.matchingPartText + '&srcRtgCd=' + gridData.sourceRouting + '&cmpntCd=' + gridData.componentCode + '&destRtgCd=' + gridData.destRouting
    + '&option=' + gridData.option+'&screenNo=NBPC_2250'+'&fileName=' +fileName;
    return this.http.get(API_URL,httpOptions)
      .pipe(
        catchError(this.error)
      )
  }

  // Handle Errors 
  error(error: HttpErrorResponse) {
    let errorMessage:any = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = error.status;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }

}


